import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1";

let csrfToken: string | null = null;
let csrfPromise: Promise<string> | null = null;

export function getCsrfToken(): string | null {
  return csrfToken;
}

/** Fetch CSRF cookie + token from the API (safe to call multiple times). */
export async function ensureCsrfToken(): Promise<string> {
  if (csrfToken) return csrfToken;
  if (csrfPromise) return csrfPromise;

  csrfPromise = axios
    .get<{ csrfToken: string }>(`${API_BASE_URL}/auth/csrf/`, { withCredentials: true })
    .then((res) => {
      csrfToken = res.data.csrfToken;
      return csrfToken;
    })
    .finally(() => {
      csrfPromise = null;
    });

  return csrfPromise;
}

export function clearCsrfToken(): void {
  csrfToken = null;
}
